// NOTE: 120, 240 and 480 widths are predefined youtube thumbnails sizes
export const AVAILABLE_IMAGE_WIDTH = [
  90, 120, 180, 320, 360, 480, 540, 768, 1024, 1280, 1366, 1440, 1600, 1680, 1920, 2560,
];
export const MAX_IMAGE_WIDTH = _.last(AVAILABLE_IMAGE_WIDTH);



// WEBPACK FOOTER //
// ./src/widget/constants/image-sizes.js